import { connect } from 'react-redux';
import VouchersFormWrapper from "../components/general/VouchersFormWrapper";
import { ADD_VOUCHER, UPDATE_VOUCHER } from "../store/actions/voucher";

const mapStateToProps = state => {
    return {
        
    };
};

const mapDispatchToProps = dispatch => {
    return {
        ADD_VOUCHER: body => dispatch(ADD_VOUCHER(body)),   
        UPDATE_VOUCHER: body => dispatch(UPDATE_VOUCHER(body)),  
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VouchersFormWrapper);


// WEBPACK FOOTER //
// ./src/containers/VouchersForm.js